import Page, { getInitialProps } from '@lib/page';

export default function Home(props:any){
	return Page(props)
}

Home.getInitialProps = (props:any) =>{
	return getInitialProps({ ...props, route_type: 'TypeIsFront', load: true })
}
